/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M0 4.75C0 2.1267 2.1267 0 4.75 0H16c2.0711 0 3.75 1.679 3.75 3.75a.75.75 0 0 1-1.5 0c0-1.2426-1.0074-2.25-2.25-2.25H4.75C2.955 1.5 1.5 2.955 1.5 4.75v14C1.5 20.5449 2.955 22 4.75 22h1.5a.75.75 0 0 1 0 1.5h-1.5C2.1267 23.5 0 21.3734 0 18.75v-14Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.6875 14.5c0 1.7604-1.4271 3.1875-3.1875 3.1875s-3.1875-1.4271-3.1875-3.1875 1.4271-3.1875 3.1875-3.1875 3.1875 1.4271 3.1875 3.1875Zm-1.5 0c0 .932-.7555 1.6875-1.6875 1.6875s-1.6875-.7555-1.6875-1.6875.7555-1.6875 1.6875-1.6875 1.6875.7555 1.6875 1.6875Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.25 21.9002a7.3903 7.3903 0 0 0 2.3012-.6154l.5493.9514a.75.75 0 1 0 1.299-.75l-.5499-.9525a7.4796 7.4796 0 0 0 1.6841-1.6841l.9525.5499a.75.75 0 1 0 .75-1.299l-.9514-.5493a7.3903 7.3903 0 0 0 .6154-2.3012H23a.75.75 0 0 0 0-1.5h-1.0998a7.3895 7.3895 0 0 0-.6154-2.3012l.9514-.5493a.75.75 0 0 0-.75-1.299l-.9525.5499a7.4798 7.4798 0 0 0-1.6841-1.6841l.5499-.9525a.75.75 0 0 0-1.299-.75l-.5493.9514a7.3889 7.3889 0 0 0-2.3012-.6154V6a.75.75 0 0 0-1.5 0v1.0998a7.3889 7.3889 0 0 0-2.3012.6154l-.5493-.9514a.75.75 0 1 0-1.299.75l.5499.9525a7.48 7.48 0 0 0-1.6841 1.6841l-.9525-.55a.75.75 0 0 0-.75 1.2991l.9514.5493a7.3889 7.3889 0 0 0-.6154 2.3012H6a.75.75 0 0 0 0 1.5h1.0998a7.3893 7.3893 0 0 0 .6154 2.3012l-.9514.5493a.75.75 0 1 0 .75 1.299l.9525-.5499a7.48 7.48 0 0 0 1.6841 1.6841l-.55.9525a.75.75 0 0 0 1.2991.75l.5493-.9514a7.3903 7.3903 0 0 0 2.3012.6154V23a.75.75 0 0 0 1.5 0v-1.0998Zm-.75-1.4627c3.2792 0 5.9375-2.6583 5.9375-5.9375S17.7792 8.5625 14.5 8.5625 8.5625 11.2208 8.5625 14.5s2.6583 5.9375 5.9375 5.9375Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuManage'
);
